"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var responsive_window_1 = require("./responsive-window");
exports.ResponsiveWindow = responsive_window_1.ResponsiveWindow;
exports.RESPONSIVEWINDOW_DIRECTIVE = [responsive_window_1.ResponsiveWindow];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3659550778/src/~/ng2-responsive/responsive-window/index.js
// module id = p7KV
// module chunks = 6